import { render, staticRenderFns } from "./GraficoCadastro.vue?vue&type=template&id=14452107&"
import script from "./GraficoCadastro.vue?vue&type=script&lang=ts&"
export * from "./GraficoCadastro.vue?vue&type=script&lang=ts&"
import style0 from "./GraficoCadastro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports